module.exports = __webpack_public_path__ + "img/wf-finishing-position-5.3022023a.svg";